const IST = "Asia/Kolkata"

function toDate(value: string | Date | undefined | null): Date | null {
  if (value == null || value === "") return null
  try {
    const date = value instanceof Date ? value : new Date(value)
    return Number.isNaN(date.getTime()) ? null : date
  } catch {
    return null
  }
}

/** Date only — e.g. 1 Jan 2026 */
export function formatIndianDate(
  value: string | Date | undefined | null,
  fallback = "—"
): string {
  const date = toDate(value)
  if (!date) {
    if (typeof value === "string" && value.trim()) return value.trim()
    return fallback
  }
  return date.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: IST,
  })
}

/** Time only — e.g. 10:30 am */
export function formatIndianTime(
  value: string | Date | undefined | null,
  fallback = "—"
): string {
  const date = toDate(value)
  if (!date) {
    if (typeof value === "string" && value.trim()) return value.trim()
    return fallback
  }
  return date.toLocaleTimeString("en-IN", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: IST,
  })
}

/** Date + time — e.g. 1 Jan 2026, 10:30 am */
export function formatIndianDateTime(
  value: string | Date | undefined | null,
  fallback = "—"
): string {
  const date = toDate(value)
  if (!date) {
    if (typeof value === "string" && value.trim()) return value.trim()
    return fallback
  }
  return `${formatIndianDate(date)}, ${formatIndianTime(date)}`
}
